import MeterRelations from './MeterRelations.yaml?component';

export { MeterRelations };
